// Diastólica fisiológica; usada para recuperar o zero que o Number() comeu.
const DIASTOLIC_MIN = 40;
const DIASTOLIC_MAX = 130;

/**
 * O totem grava a PA como Number(`${sbp}.${dbp}`): 120/80 vira 120.8 e 130/100 vira 130.1.
 * Recompõe a diastólica tentando devolver os zeros à direita até cair numa faixa plausível.
 */
export function formatBloodPressure(value: number | null | undefined): string {
  if (!value) return '';

  const [systolic, fraction = ''] = String(value).split('.');
  if (!fraction) return systolic;

  const diastolic = [fraction, `${fraction}0`, `${fraction}00`].find((candidate) => {
    const number = Number(candidate);
    return number >= DIASTOLIC_MIN && number <= DIASTOLIC_MAX;
  });

  return `${systolic}/${diastolic ?? fraction}`;
}

const TRIAGE_ANSWERS: Record<string, string> = {
  yes: 'Sim',
  no: 'Não',
  unknown: 'Não sei'
};

/** Respostas da triagem vêm como o value da opção no totem (yes/no/unknown). */
export function formatTriageAnswer(value: string | null | undefined): string {
  if (!value) return '—';
  return TRIAGE_ANSWERS[value.toLowerCase()] ?? value;
}

// BloodPressureGroup do totem (react-native-app e electron-app), gravado como string.
const BLOOD_PRESSURE_GROUPS: Record<string, string> = {
  '0': 'Normal',
  '1': 'Pré-hipertensão',
  '2': 'Hipertensão'
};

/** Pergunta "Qual é sua pressão arterial normal?" da triagem. */
export function formatBloodPressureGroup(value: string | null | undefined): string {
  if (!value) return '—';
  return BLOOD_PRESSURE_GROUPS[value] ?? formatTriageAnswer(value);
}

/** Altura digitada no totem em metros (1.75) ou centímetros (175). */
export function heightInCm(value: number | null | undefined): number | null {
  if (!value) return null;
  return value <= 3 ? Math.round(value * 100) : value;
}
